export default __webpack_public_path__ + "static/media/banner_05.996aaa46.png";